export default function Products() {
  return (
    <section className="py-32 bg-[#FAFAFA]">
      <div className="max-w-[1440px] mx-auto px-20">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h3 className="text-6xl font-bold text-[#1A1A1A] mb-6">Our Products</h3>
          <p className="text-lg text-[#666666]">
            Innovative solutions designed for iOS users
          </p>
        </div>

        {/* Product Grid */}
        <div className="flex gap-6" data-product-shop>
          {/* Left Large Card - VPN */}
          <div className="w-1/2 group cursor-pointer">
            <div className="relative h-[680px] rounded-[32px] bg-gradient-to-br from-[#6B46C1] to-[#4A9FFF] overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,0.12)] transition-transform duration-300 hover:scale-[1.02]">
              <div className="absolute inset-0 flex items-center justify-center p-12">
                <img
                  src="https://public.readdy.ai/ai/img_res/420eb0707bcd54ae3763113fce69e21f.jpg"
                  alt="VPN Shield"
                  className="w-full h-full object-contain object-center"
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-10 bg-gradient-to-t from-black/80 to-transparent">
                <h4 className="text-3xl font-bold text-white mb-3">VPN Shield</h4>
                <p className="text-base text-white/90 leading-relaxed max-w-md">
                  Secure your online privacy with our advanced VPN solution. Fast, reliable, and easy to use, protecting your data across all networks.
                </p>
              </div>
            </div>
          </div>

          {/* Right Stacked Cards */}
          <div className="w-1/2 flex flex-col gap-6">
            {/* Cleaner Product */}
            <div className="h-[337px] group cursor-pointer">
              <div className="relative h-full rounded-[32px] bg-gradient-to-br from-[#A8E6CF] to-[#56CCF2] overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,0.12)] transition-transform duration-300 hover:scale-[1.02]">
                <div className="absolute inset-0 flex items-center justify-center p-8">
                  <img
                    src="https://readdy.ai/api/search-image?query=iPhone%20mockup%20showing%20cleaner%20optimization%20app%20interface%20with%20storage%20management%20and%20performance%20boost%20features%2C%20mint%20and%20teal%20gradient%20background%2C%20modern%20iOS%20design%2C%20clean%20interface%2C%20professional%20product%20photography%2C%20high%20quality%20render&width=700&height=500&seq=product-cleaner-001&orientation=landscape"
                    alt="Device Cleaner"
                    className="w-full h-full object-contain object-center"
                  />
                </div>
                <div className="absolute bottom-0 right-0 p-8 bg-white/20 backdrop-blur-md rounded-tl-[24px] max-w-sm">
                  <h4 className="text-2xl font-bold text-[#1A1A1A] mb-2">Device Cleaner</h4>
                  <p className="text-sm text-[#2D2D2D] leading-relaxed">
                    Optimize your device performance with intelligent cleaning and storage management tools.
                  </p>
                </div>
              </div>
            </div>

            {/* Technology Focus */}
            <div className="h-[337px] group cursor-pointer">
              <div className="relative h-full rounded-[32px] bg-gradient-to-br from-[#FFB6B9] to-[#FEC8D8] overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,0.12)] transition-transform duration-300 hover:scale-[1.02]">
                <div className="absolute inset-0 flex items-center justify-center p-8">
                  <img
                    src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20of%20iOS%20code%20snippets%20and%20UI%20elements%20floating%20in%20space%2C%20modern%20software%20development%20visualization%2C%20coral%20and%20pink%20gradient%20background%2C%20minimalist%20tech%20aesthetic%2C%20geometric%20shapes%2C%20professional%20digital%20art%2C%20clean%20and%20approachable%20style&width=700&height=500&seq=product-tech-001&orientation=landscape"
                    alt="Technology"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="absolute bottom-0 left-0 p-8 bg-white/20 backdrop-blur-md rounded-tr-[24px] max-w-sm">
                  <h4 className="text-2xl font-bold text-[#1A1A1A] mb-2">Advanced Technology</h4>
                  <p className="text-sm text-[#2D2D2D] leading-relaxed">
                    Built with cutting-edge iOS technologies for optimal performance and reliability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}